import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Snackbar, Alert } from "@mui/material";
import { LandingHeader } from "src/components/LandingPage/LandingHeader";
import { CustomText } from "src/design";
import { useTranslation } from "react-i18next";
import { useVerifyEmail } from "src/data/account/owner";

const EmailVerificationPage = () => {
  const { token } = useParams();
  const { t } = useTranslation();
  const { mutate: verifyEmail, data, isError } = useVerifyEmail();

  useEffect(() => {
    if (token) {
      verifyEmail(token);
    }
  }, [token, verifyEmail]);

  const verified = !isError && !!data?.success;
  const failed = isError || (!!data && !data.success);
  const isMobile = data?.isMobile ?? false;

  const [showFailedSnackbar, setShowFailedSnackbar] = useState(failed);
  const [showVerifiedSnackbar, setShowVerifiedSnackbar] = useState(verified);

  return (
    <Grid>
      <LandingHeader compact />
      <Grid
        container
        sx={{ width: "100%", minHeight: "92vh" }}
        justifyContent="center"
        alignContent="center"
      >
        <Grid item>
          <CustomText
            label={t("emailVerification.body")}
            type="body"
            size={undefined}
          />
        </Grid>
        <Snackbar
          open={showVerifiedSnackbar}
          autoHideDuration={6000}
          onClose={() => setShowVerifiedSnackbar(false)}
        >
          <Alert
            onClose={() => setShowVerifiedSnackbar(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {t(
              isMobile
                ? "emailVerification.mobile.success"
                : "emailVerification.website.success",
            )}
          </Alert>
        </Snackbar>
        <Snackbar
          open={showFailedSnackbar}
          autoHideDuration={6000}
          onClose={() => setShowFailedSnackbar(false)}
        >
          <Alert
            onClose={() => setShowFailedSnackbar(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {t(
              isError
                ? "emailVerification.crash"
                : isMobile
                  ? "emailVerification.mobile.error"
                  : "emailVerification.website.error",
            )}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
};

export default EmailVerificationPage;
